const ruleRoutes = [
  {
    path: 'rules',
    name: 'Rules',
    component: () => import('./pages/RulesListPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'rules/new',
    name: 'RuleCreate',
    component: () => import('./pages/GuidedRuleWizardPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'rules/new/legacy',
    name: 'RuleCreateLegacy',
    component: () => import('./pages/RuleWizardPage.vue'),
    props: { mode: 'create' },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'rules/new/agentic',
    name: 'AgenticRuleCreate',
    component: () => import('./pages/AgenticRuleBuilderPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'rules/:id/edit',
    name: 'RuleEdit',
    component: () => import('./pages/RuleWizardPage.vue'),
    props: route => ({ mode: 'edit', ruleId: route.params.id }),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'rules/:id',
    name: 'RuleDetail',
    component: () => import('./pages/RuleDetailPage.vue'),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  // Temporary redirects preserve bookmarks while the canonical routes settle.
  {
    path: 'builder',
    redirect: { name: 'RuleCreate' },
  },
  {
    path: 'builder/simple',
    redirect: { name: 'RuleCreateLegacy' },
  },
  {
    path: 'builder/advanced',
    redirect: { name: 'RuleCreateLegacy' },
  },
  {
    path: 'builder/agentic',
    redirect: { name: 'AgenticRuleCreate' },
  },
  {
    path: 'rules/editor/create',
    redirect: { name: 'RuleCreateLegacy' },
  },
  {
    path: 'rules/editor/update/:ruleId',
    redirect: route => ({ name: 'RuleEdit', params: { id: route.params.ruleId } }),
  },
]

export default ruleRoutes
